// Preserve legacy form initialization, comparisons, and import order.
/* eslint-disable import/order, no-unneeded-ternary, sonarjs/prefer-immediate-return, spaced-comment */
import type { ChangeEvent } from 'react'
import type { SetPositionProductType } from 'utils/apiList/setPosition'
import { memo, useEffect, useState } from 'react'
import styled from 'styled-components'
import { TextBody, Input, Button } from 'components'
import icon_box from 'assets/images/box-item.svg'
import { postPosition } from 'storeContext/actions/setPosition/setPositionProduct'
import { useSetPositionContext } from 'storeContext/hooks/useSetPositionContext'

interface RowSetPositionProductPropsType {
  data: SetPositionProductType
  isAllowedForSetPosition?: boolean
}

function RowSetPositionProduct({ data, isAllowedForSetPosition }: RowSetPositionProductPropsType) {
  const { dispatch: dispatchSetPosition } = useSetPositionContext()

  //STATE HOOKS
  const [formValRow, setFormValRow] = useState<Partial<SetPositionProductType>>({})

  //FUNCTION HELPER
  const getParams = (paramsKey: string) => {
    const urlParams = new URLSearchParams(window.location.search)
    const myParam = urlParams.get(paramsKey)
    return myParam
  }

  //EFFECT HOOKS
  useEffect(() => {
    setFormValRow(data)
  }, [data])

  //FUNCTION HANDLER
  const handleChangeForm = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, name } = e.target

    setFormValRow({
      ...formValRow,
      [name]: value, //removeZeroOnFirst(numberOnly(value))
    })
  }

  const handleAddPosition = () => {
    const dataToSend = {
      category_id: getParams('categoryID'),
      product_id: data?.product_id,
      position: formValRow.position,
    }
    dispatchSetPosition(postPosition(dataToSend))
  }

  return (
    <Tr>
      <Td ratio="4">
        <ProductWrapper>
          <ImgCategory
            size="32px"
            alt="box"
            src={data?.product_image ? data?.product_image : icon_box}
          />
          <TextBody weight="light" color="textSoft">
            {data?.product_name}
          </TextBody>
        </ProductWrapper>
      </Td>
      <Td ratio="3">
        <TextBody weight="light" color="textSoft">
          {data?.product_sku_number}
        </TextBody>
      </Td>
      <Td ratio="2">
        {isAllowedForSetPosition && (
          <InputWrapper>
            <Input
              type="number"
              name="position"
              value={formValRow?.position}
              onChange={handleChangeForm}
            />
          </InputWrapper>
        )}
      </Td>
      <Td ratio="1">
        {isAllowedForSetPosition && (
          <WrapperActions>
            {(formValRow?.position === 0 ? 0 : parseInt(formValRow?.position as string, 10)) !==
              (data?.position === 0 ? 0 : parseInt(data?.position as string, 10)) && (
              <Button size="small" onClick={handleAddPosition}>
                Simpan
              </Button>
            )}
          </WrapperActions>
        )}
      </Td>
    </Tr>
  )
}

export default memo(RowSetPositionProduct)

const Tr = styled.tr`
  display: flex;
  padding: 12px 32px;
  background-color: ${({ theme: { colors } }) => colors.white};
  border-bottom: 1px solid #f3f6fa;
  align-items: center;
`
const Td = styled.td<{ ratio: string }>`
  color: ${({ theme: { colors } }) => colors.grey};
  /* font-weight: ${({ theme: { fontWeights } }) => fontWeights.light}; */
  font-size: ${({ theme: { fontSizes } }) => fontSizes.smaller};
  flex: ${({ ratio }) => ratio};
  text-align: start;
`
const ImgCategory = styled.img<{ size: string }>`
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  border-radius: 5px;
  background-color: ${({ theme: { colors } }) => colors.mainFaded};
  border: none;
`

const ProductWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const WrapperActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

const InputWrapper = styled.div`
  margin-right: 24px;
`
